module.exports = __webpack_public_path__ + "img/iot8.c79d95a9.png";